import React from 'react';
import { ultimasNoticias } from '../../json/ultimasNoticias';
import './ultimasnoticias.css';

const UltimasNoticias = () => {
  return (
    <div id='ultimas_noticias'>
      <div className='row'>
        <div className='col-12'>
          <div className='notice_section'>
            <div className='notice_title'>
              <h3 className='title'>ÚLTIMAS NOTICIAS</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='notice_content_full'>
              <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                  {
                    ultimasNoticias.map((item, index)=>(
                      <div key={ index } className={ index >= 1 ? "carousel-item" : "carousel-item active" }>
                        <a href={ item.url } target="_blank" rel="noopener noreferrer">
                          <div className="img-carousel d-block w-100" style={{ backgroundImage: `url("${ item.imagen }")` }} alt="First slide">
                            <div className='title_img_carousel'>
                              <h6>{ item.titulo }</h6>
                              <p>{ item.fecha }</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))
                  }
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UltimasNoticias